import React, { useContext } from 'react'

import AppContext from '../../../App/context'
import Avatar from '../../../Avatar/me'
import { MenuBase } from 'karrierhub-ui/dist/common/src/components/Menu'

export function UserMenuBase(props) {

    const {
        user,
        classNames,
        size,
        MenuBaseProps = {}
    } = props

    const appContext = useContext(AppContext)

    return (
        <div className={classNames.userMenuBase}>
            <Avatar
                box={true}
                welcomeText={appContext.messages.avatarWelcomeText}
                style={{ marginBottom: '30px' }}
                inline={true}
                href={appContext.routes.userRoute + '/' + user?._id}
                secondaryText={''}
            />
            <MenuBase
                {...MenuBaseProps}
                PaperProps={{
                    color: 'paper1',
                    variant: 'text',
                    size: 'none',
                    elevation: 0,
                    style: {
                        width: '100%'
                    }
                }}
                MenuItemProps={{
                    size
                }}
            />
        </div>
    )
}
